export const getLoading = (state) => state.additionalDrivers.loading;
export const getOpen = (state) => state.additionalDrivers.open;
export const getEmail = (state) => state.additionalDrivers.email;
export const getDriver = (state) => state.additionalDrivers.driver;
